// ADDITIONAL IMPORTS
// import * as moment from "moment";

// CONFIGURATION
// import "./../../../app-config/{env}/properties";
import "./../../../app-config/properties";
import "./schoolwork12";

// COMMON
import "../../common/common.js";
import "../../common/services/eventNotification.js";
import "../../common/services/storage.js";
import "../../common/services/utilService.js";

// MODULES
import "../../auth/auth";
import "../../auth/services/auth.service.js";
import "../../auth/auth-route-listener.js";
import "../../auth/directives/ssoClick.js";
import "../../auth/controllers/loginController.js";
import "../../auth/controllers/logoutController.js";
import "../../auth/controllers/keycodeLoginController.js";

import "../../header/header.js";
import "../../header/controllers/headerLinks.js";

import "../../student/student.js";
import "../../student/directives/moveMenu.js";
import "../../student/controllers/StudentSearch.js";
import "../../student/controllers/studentDetails.js";
import "../../student/controllers/studentGradPlan.js";
import "../../student/controllers/studentBySubject.js";

import "../../student/controllers/studentTabContent.js";
import "../../student/services/studentAddClassroom.js";
import "../../student/services/studentAdjustAttendance.js";
import "../../student/services/studentAssignGradPlan.js";
import "../../student/services/manageStudentData.js";
import "../../student/services/studentLockCurriculum.js";
import "../../student/services/studentUnlockCurriculum.js";
import "../../student/services/studentAddPersonalGroup.js";
import "../../student/services/studentCreatePersonalGroup.js";
import "../../student/services/studentRemovePersonalGroup.js";
import "../../student/services/gradPlanService.js";
import "../../student/services/studentAttendanceAdjustment.js";
import "../../student/services/manageSchoolData.js";
import "../../student/services/personalGroupService.js";
import "../../student/services/studentSaveSearch.js";

import "../../fulfillment/computerFulfillment.js";
import "../../fulfillment/services/schoolservice.js";
import "../../fulfillment/controllers/fulfillment.js";

import "../../fulfillmentApproval/fulfillmentApproval.js";
import "../../fulfillmentApproval/controllers/fulfillmentSearchAndApproval.js";

import "../../submissionLogs/submissionLogs.js";
import "../../submissionLogs/controllers/submissionLogs.js";
import "../../submissionLogs/services/submissionLogs.js";

import "../../graduationPlan/graduationPlan.js";
import "../../graduationPlan/controllers/manageGraduationPlan.js";
import "../../graduationPlan/controllers/addSchoolPlan.js";
import "../../graduationPlan/controllers/editSchoolPlan.js";
import "../../graduationPlan/services/manageGradPlan.js";
import "../../graduationPlan/controllers/subjectCriteriaController.js";

import "../../schoolData/schoolData.js";
import "../../schoolData/services/schoolDataEdit.js";
import "../../schoolData/controllers/manageSchoolData.js";
import "../../schoolData/controllers/schoolDataDetails.js";


import "../../k12DataManagement/k12DataManagement.js";
import "../../k12DataManagement/services/k12DataManagement.js";
import "../../k12DataManagement/controllers/k12DataManagement.js";
import "../../k12DataManagement/controllers/addClusterConfig.js";
import "../../k12DataManagement/controllers/systemConfiguration.js";


import "../../bulkImport/bulkImport.js";
import "../../bulkImport/directives/fileModel.js";
import "../../bulkImport/controllers/bulkImport.js";
import "../../bulkImport/services/bulkImportService.js";

import "../../studentView_gradPlan/studentView.js";
import "../../studentView_gradPlan/controllers/studentGpView.js";
import "../../studentView_gradPlan/controllers/studentViewBySubject.js";

import "../../mailTemplates/mailTemplate.js";
import "../../mailTemplates/controllers/manageMailTemplate.js";
import "../../mailTemplates/controllers/addMailTemplate.js";
import "../../mailTemplates/controllers/editMailTemplate.js";
import "../../mailTemplates/services/manageMailTemplate.js";

import "../../administrationTools/administrationTools.js";
import "../../administrationTools/controllers/administrationTools.js";
import "../../administrationTools/controllers/withdrawPerson.js";
import "../../administrationTools/services/withdrawPerson.js";
import "../../administrationTools/services/administrationTools.js";
import "../../administrationTools/controllers/fixDuplicateAdults.js";
import "../../administrationTools/controllers/reactivateAdults.js";

import "../../courseManagement/courseManagement.js";
import "../../courseManagement/controllers/manageCourseManagement.js";
import "../../courseManagement/controllers/addCourse.js";
import "../../courseManagement/controllers/editCourse.js";
import "../../courseManagement/services/manageCourseManagement.js";

import "../../components/version/version.js";
import "../../components/version/version-directive.js";
import "../../components/version/interpolate-filter.js";

import "../../app.ts";
